import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './ErrorMessage.module.scss';
const ErrorMessage = ({ error, className = '' }) => {
    return _jsx("p", Object.assign({ className: `${styles.errorMessage} ${className}` }, { children: error }));
};
export default ErrorMessage;
